export enum EndUnit {
  MB = 'MB',
  KB = 'KB',
}
